
export const buildActions = (moduleName, prefix, suffix) => ({
    STARTED: `${moduleName}/${prefix}_${suffix || ''}${suffix ? '_' : ''}STARTED`,
    FAILED: `${moduleName}/${prefix}_${suffix || ''}${suffix ? '_' : ''}FAILED`,
    FULFILLED: `${moduleName}/${prefix}_${suffix || ''}${suffix ? '_' : ''}FULFILLED`,
});